import {AxiosPromise, AxiosResponse} from 'axios'
import Client from 'core/api/client'

/** Interface representing the parameters needed for the auth heartbeat request */
export interface IHeartbeatRequest {
  /** The value of the extend query parameter. Used to flag if the current auth token expiry should be extended */
  extend: boolean
}

interface HeartbeatResponsePayload {
  /** Flag signifying if the user is still authenticated */
  isAuthenticated: boolean
  /** Amount of time left before the token expires (in milliseconds) */
  remainingTime: number
}

/** Interface representing the response body of the auth heartbeat request */
export interface IHeartbeatResponse extends AxiosResponse {
  data: HeartbeatResponsePayload
}

/**
 * GET /auth/heartbeat
 * Performs the auth heartbeat for the provided token
 * @param {string | undefined} token The auth token to perform the heartbeat on.
 * @param {IHeartbeatRequest} data
 * @returns {Promise<IHeartbeatResponse>}
 */
export function heartbeat(token: string | undefined, data: IHeartbeatRequest): AxiosPromise<IHeartbeatResponse> {
  const headers = token ? { Authorization: `Bearer ${token}` } : {}
  return Client.get('/auth/heartbeat', {
    headers,
    params: {
      extend: data.extend,
    },
    validateStatus: () => true,
  })
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/auth/index.ts